import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';
import { type JsonNode, useBowtieJobGetByIdQuery } from '../api/generated/bowtie-api';

interface UseGetAIBackgroundJobResultProps {
  jobId: string;
  setJobId: Dispatch<SetStateAction<string | undefined>>;
}

export const useGetAIBackgroundJobResult = ({ jobId, setJobId }: UseGetAIBackgroundJobResultProps) => {
  const [data, setData] = useState<JsonNode>();
  const [error, setError] = useState<boolean>(false);

  const { data: { status, result } = {}, isError } = useBowtieJobGetByIdQuery(
    { jobId: jobId! },
    {
      skip: !jobId,
      pollingInterval: jobId ? 5000 : 0, // 5 seconds polling interval
    }
  );

  useEffect(() => {
    if ('FINISHED' === status) {
      setData(result);
      setError(false);
      setJobId(undefined);
    } else if ('FAILED' === status || isError) {
      setData(undefined);
      setError(true);
      setJobId(undefined);
    }
  }, [status, isError]);

  return { data, error: error, loading: !!jobId };
};
